<p-toast position="top-right" />
<div class="flex flex-col justify-between min-h-screen">
  <app-header [hideActions]="isChromeless()" />
  <main class="flex-1">
    <router-outlet />
  </main>
  <app-footer [hideActions]="isChromeless()" />
</div>
